import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "generate",
  "description": "API reference for the `turbo generate` command"
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "Extend your Turborepo with new apps and packages."
  }, {
    "heading": "",
    "content": "turbo generate run [generator-name]: Run custom generators defined in your repository."
  }, {
    "heading": "",
    "content": "turbo generate workspace [options]: Create a new package in your repository by copying an existing one or from the start."
  }, {
    "heading": "",
    "content": "For more information and practical use cases for writing custom generators, visit the \"Generating code\" guide."
  }, {
    "heading": "",
    "content": "turbo gen is an alias for turbo generate. Additionally, run is the\ndefault command so turbo gen is equivalent to turbo generate run."
  }, {
    "heading": "run-generator-name",
    "content": "Run custom generators defined in your repository."
  }, {
    "heading": "--args",
    "content": "Answers to pass directly to the generator's prompts."
  }, {
    "heading": "--config-path",
    "content": "Generator configuration file."
  }, {
    "heading": "--config-path",
    "content": "Default: turbo/generators/config.js"
  }, {
    "heading": "--root-path",
    "content": "The root of your repository"
  }, {
    "heading": "--root-path",
    "content": "Default: directory with root turbo.json"
  }, {
    "heading": "workspace",
    "content": "Create a new workspace."
  }, {
    "heading": "--name-name",
    "content": "The name for the new workspace to be used in the package.json name key. The name key is the unique identifier for the package in your repository."
  }, {
    "heading": "--empty",
    "content": "Creates an empty workspace. Defaults to true."
  }, {
    "heading": "--copy-nameurl",
    "content": "Name of local workspace within your monorepo or a fully qualified GitHub URL with any branch and/or subdirectory."
  }, {
    "heading": "--destination-path",
    "content": "Where the new workspace should be created."
  }, {
    "heading": "--type-apppackage",
    "content": "The type of workspace to create (app or package)."
  }, {
    "heading": "--root-path-1",
    "content": "The root of your repository. Defaults to the directory of the root turbo.json."
  }, {
    "heading": "--show-all-dependencies",
    "content": "Prevent filtering dependencies by workspace type when selecting dependencies to add."
  }, {
    "heading": "--example-path-path--p-path",
    "content": "In a rare case, your GitHub URL might contain a branch name with a slash (e.g. bug/fix-1) and the path to the example (e.g. foo/bar). In this case, you must specify the path to the example separately."
  }],
  "headings": [{
    "id": "run-generator-name",
    "content": "run [generator-name]"
  }, {
    "id": "flag-options",
    "content": "Flag options"
  }, {
    "id": "--args",
    "content": "--args"
  }, {
    "id": "--config-path",
    "content": "--config <path>"
  }, {
    "id": "--root-path",
    "content": "--root <path>"
  }, {
    "id": "workspace",
    "content": "workspace"
  }, {
    "id": "flag-options-1",
    "content": "Flag options"
  }, {
    "id": "--name-name",
    "content": "--name <name>"
  }, {
    "id": "--empty",
    "content": "--empty"
  }, {
    "id": "--copy-nameurl",
    "content": "--copy <name>/<url>"
  }, {
    "id": "--destination-path",
    "content": "--destination <path>"
  }, {
    "id": "--type-apppackage",
    "content": "--type <app/package>"
  }, {
    "id": "--root-path-1",
    "content": "--root <path>"
  }, {
    "id": "--show-all-dependencies",
    "content": "--show-all-dependencies"
  }, {
    "id": "--example-path-path--p-path",
    "content": "--example-path <path>, -p <path>"
  }]
};
import {Callout} from '#components/callout';
export const toc = [{
  depth: 2,
  url: "#run-generator-name",
  title: _jsx(_Fragment, {
    children: _jsx("code", {
      children: "run [generator-name]"
    })
  })
}, {
  depth: 3,
  url: "#flag-options",
  title: _jsx(_Fragment, {
    children: "Flag options"
  })
}, {
  depth: 4,
  url: "#--args",
  title: _jsx(_Fragment, {
    children: _jsx("code", {
      children: "--args"
    })
  })
}, {
  depth: 4,
  url: "#--config-path",
  title: _jsx(_Fragment, {
    children: _jsx("code", {
      children: "--config <path>"
    })
  })
}, {
  depth: 4,
  url: "#--root-path",
  title: _jsx(_Fragment, {
    children: _jsx("code", {
      children: "--root <path>"
    })
  })
}, {
  depth: 2,
  url: "#workspace",
  title: _jsx(_Fragment, {
    children: _jsx("code", {
      children: "workspace"
    })
  })
}, {
  depth: 3,
  url: "#flag-options-1",
  title: _jsx(_Fragment, {
    children: "Flag options"
  })
}, {
  depth: 4,
  url: "#--name-name",
  title: _jsx(_Fragment, {
    children: _jsx("code", {
      children: "--name <name>"
    })
  })
}, {
  depth: 4,
  url: "#--empty",
  title: _jsx(_Fragment, {
    children: _jsx("code", {
      children: "--empty"
    })
  })
}, {
  depth: 4,
  url: "#--copy-nameurl",
  title: _jsx(_Fragment, {
    children: _jsx("code", {
      children: "--copy <name>/<url>"
    })
  })
}, {
  depth: 4,
  url: "#--destination-path",
  title: _jsx(_Fragment, {
    children: _jsx("code", {
      children: "--destination <path>"
    })
  })
}, {
  depth: 4,
  url: "#--type-apppackage",
  title: _jsx(_Fragment, {
    children: _jsx("code", {
      children: "--type <app/package>"
    })
  })
}, {
  depth: 4,
  url: "#--root-path-1",
  title: _jsx(_Fragment, {
    children: _jsx("code", {
      children: "--root <path>"
    })
  })
}, {
  depth: 4,
  url: "#--show-all-dependencies",
  title: _jsx(_Fragment, {
    children: _jsx("code", {
      children: "--show-all-dependencies"
    })
  })
}, {
  depth: 4,
  url: "#--example-path-path--p-path",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "--example-path <path>"
    }), ", ", _jsx("code", {
      children: "-p <path>"
    })]
  })
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    h2: "h2",
    h3: "h3",
    h4: "h4",
    li: "li",
    p: "p",
    pre: "pre",
    span: "span",
    ul: "ul",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.p, {
      children: "Extend your Turborepo with new apps and packages."
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " generate"
            })]
          })
        })
      })
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "#run-generator-name",
          children: _jsx(_components.code, {
            children: "turbo generate run [generator-name]"
          })
        }), ": Run custom generators defined in your repository."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "#workspace",
          children: _jsx(_components.code, {
            children: "turbo generate workspace [options]"
          })
        }), ": Create a new package in your repository by copying an existing one or from the start."]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["For more information and practical use cases for writing custom generators, visit ", _jsx(_components.a, {
        href: "/docs/guides/generating-code",
        children: "the \"Generating code\" guide"
      }), "."]
    }), "\n", _jsx(Callout, {
      type: "good-to-know",
      children: _jsxs(_components.p, {
        children: [_jsx(_components.code, {
          children: "turbo gen"
        }), " is an alias for ", _jsx(_components.code, {
          children: "turbo generate"
        }), ". Additionally, ", _jsx(_components.code, {
          children: "run"
        }), " is the\ndefault command so ", _jsx(_components.code, {
          children: "turbo gen"
        }), " is equivalent to ", _jsx(_components.code, {
          children: "turbo generate run"
        }), "."]
      })
    }), "\n", _jsx(_components.h2, {
      id: "run-generator-name",
      children: _jsx(_components.code, {
        children: "run [generator-name]"
      })
    }), "\n", _jsx(_components.p, {
      children: "Run custom generators defined in your repository."
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " gen"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " run"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " [generator-name]"
            })]
          })
        })
      })
    }), "\n", _jsx(_components.h3, {
      id: "flag-options",
      children: "Flag options"
    }), "\n", _jsx(_components.h4, {
      id: "--args",
      children: _jsx(_components.code, {
        children: "--args"
      })
    }), "\n", _jsx(_components.p, {
      children: "Answers to pass directly to the generator's prompts."
    }), "\n", _jsx(_components.h4, {
      id: "--config-path",
      children: _jsx(_components.code, {
        children: "--config <path>"
      })
    }), "\n", _jsx(_components.p, {
      children: "Generator configuration file."
    }), "\n", _jsxs(_components.p, {
      children: ["Default: ", _jsx(_components.code, {
        children: "turbo/generators/config.js"
      })]
    }), "\n", _jsx(_components.h4, {
      id: "--root-path",
      children: _jsx(_components.code, {
        children: "--root <path>"
      })
    }), "\n", _jsx(_components.p, {
      children: "The root of your repository"
    }), "\n", _jsxs(_components.p, {
      children: ["Default: directory with root ", _jsx(_components.code, {
        children: "turbo.json"
      })]
    }), "\n", _jsx(_components.h2, {
      id: "workspace",
      children: _jsx(_components.code, {
        children: "workspace"
      })
    }), "\n", _jsx(_components.p, {
      children: "Create a new workspace."
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " gen"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " workspace"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " [options]"
            })]
          })
        })
      })
    }), "\n", _jsx(_components.h3, {
      id: "flag-options-1",
      children: "Flag options"
    }), "\n", _jsx(_components.h4, {
      id: "--name-name",
      children: _jsx(_components.code, {
        children: "--name <name>"
      })
    }), "\n", _jsxs(_components.p, {
      children: ["The name for the new workspace to be used in the ", _jsx(_components.code, {
        children: "package.json"
      }), " ", _jsx(_components.code, {
        children: "name"
      }), " key. The ", _jsx(_components.code, {
        children: "name"
      }), " key is the unique identifier for the package in your repository."]
    }), "\n", _jsx(_components.h4, {
      id: "--empty",
      children: _jsx(_components.code, {
        children: "--empty"
      })
    }), "\n", _jsxs(_components.p, {
      children: ["Creates an empty workspace. Defaults to ", _jsx(_components.code, {
        children: "true"
      }), "."]
    }), "\n", _jsx(_components.h4, {
      id: "--copy-nameurl",
      children: _jsx(_components.code, {
        children: "--copy <name>/<url>"
      })
    }), "\n", _jsx(_components.p, {
      children: "Name of local workspace within your monorepo or a fully qualified GitHub URL with any branch and/or subdirectory."
    }), "\n", _jsx(_components.h4, {
      id: "--destination-path",
      children: _jsx(_components.code, {
        children: "--destination <path>"
      })
    }), "\n", _jsx(_components.p, {
      children: "Where the new workspace should be created."
    }), "\n", _jsx(_components.h4, {
      id: "--type-apppackage",
      children: _jsx(_components.code, {
        children: "--type <app/package>"
      })
    }), "\n", _jsxs(_components.p, {
      children: ["The type of workspace to create (", _jsx(_components.code, {
        children: "app"
      }), " or ", _jsx(_components.code, {
        children: "package"
      }), ")."]
    }), "\n", _jsx(_components.h4, {
      id: "--root-path-1",
      children: _jsx(_components.code, {
        children: "--root <path>"
      })
    }), "\n", _jsxs(_components.p, {
      children: ["The root of your repository. Defaults to the directory of the root ", _jsx(_components.code, {
        children: "turbo.json"
      }), "."]
    }), "\n", _jsx(_components.h4, {
      id: "--show-all-dependencies",
      children: _jsx(_components.code, {
        children: "--show-all-dependencies"
      })
    }), "\n", _jsx(_components.p, {
      children: "Prevent filtering dependencies by workspace type when selecting dependencies to add."
    }), "\n", _jsxs(_components.h4, {
      id: "--example-path-path--p-path",
      children: [_jsx(_components.code, {
        children: "--example-path <path>"
      }), ", ", _jsx(_components.code, {
        children: "-p <path>"
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["In a rare case, your GitHub URL might contain a branch name with a slash (e.g. ", _jsx(_components.code, {
        children: "bug/fix-1"
      }), ") and the path to the example (e.g. ", _jsx(_components.code, {
        children: "foo/bar"
      }), "). In this case, you must specify the path to the example separately."]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
